<template>
    <el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				账户信息
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true"   style="text-align: right;">
					<el-form-item>
						<el-button type="info" @click="getInfo()">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
        <div class="account-info" v-loading="dataListLoading">
            <div class="account-info-item" style="margin-bottom:30px"> 
                <div class="account-info-item-title">基本信息</div>
                <div>
                    <div class="account-info-inline">
                        用户类型：<span style="color: #333333;">{{accountInfo.userType == 'qyyh'?'企业用户':''}}</span>
                    </div>
                    <div class="account-info-inline">
                        用户名称：<span style="color: #333333;">{{accountInfo.name}}</span>
                    </div>
                    <div class="account-info-inline">
                        账户状态：<span style="color: #333333;"><el-tag v-if="accountInfo.status == 0" size="small" type="danger">{{ $t('user.status0') }}</el-tag><el-tag v-else size="small" type="success">{{ $t('user.status1') }}</el-tag></span>
                    </div>
                    <div class="account-info-inline">
                        开户日期：<span style="color: #333333;">{{accountInfo.spdbDate}}</span>
                    </div>
                </div>
            </div>
            <div class="account-info-item">
                <div class="account-info-item-title">账户信息</div>
                <div>
                   <div class="account-info-inline">
                        开户行：<span style="color: #333333;">{{accountInfo.bankName}}</span>
                    </div>
                    <div class="account-info-inline">
                        银行账户：<span style="color: #333333;">{{useInfo.bankAccount}}</span>
                    </div>
                    <div class="account-info-inline">
                        子账户：<span style="color: #333333;">{{accountInfo.childAcctNo}}</span>
                    </div>
                    <div class="account-info-inline">
                        账户余额：<span style="color: #333333;">{{accountInfo.balance}}</span>
                    </div>
                    <div class="account-info-inline">
                        累计充值（收款）余额：<span style="color: #333333;">{{accountInfo.totalChargeAmount}}</span>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>
<script>
export default {
    name:'account-info',
    data(){
        return {
            useInfo:{},
            accountInfo:{},
            dataListLoading:false
        }
    },
    mounted(){
        this.getInfo();
    },
    methods:{
        getInfo () {
            this.dataListLoading = true;
            this.$http.get(`/sys/user/info`).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.$http.get(`/sys/plat/info/ca/getInfoByUserId?userId=` + res.data.id).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.useInfo = res.data;
                    this.accountInfo = res.data.bankAccountDTOList[0];
                    this.dataListLoading = false;
                }).catch(() => {
                    this.dataListLoading = false;
                })
            }).catch(() => {
                this.dataListLoading = false;
            })
        },
    }
    
}
</script>
<style scoped lang="scss">
    .account-info{
        padding-top: 50px;
        padding-left: 50px;
        padding-right: 50px;
        .account-info-item{
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.16);
            border-radius: 6px;
            padding: 25px;
            .account-info-item-title{
                font-size: 18px;
                color: #333333;
                margin-bottom: 50px;
                font-family: PingFang SC;
                &.account-info-item-title:before{
                    content: '';
                    width: 12px;
                    height: 12px;
                    background: #5194FD;
                    display: inline-block;
                    margin-right: 6px;
                    border-radius: 50%;
                    position: relative;
                    top: -2px;
                }
            }
            .account-info-inline{
                width: 350px;
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                display: inline-block;
                color: #666666;
            }
        }
    }
</style>